import { Outlet } from "react-router-dom";
import OrdersTopNav from "./OrdersTopNav";

const OrdersLayout = () => {
  return (
    <div className="laam-module">
      <OrdersTopNav />
      <div className="laam-content">
        <Outlet />
      </div>
    </div>
  );
};

export default OrdersLayout;
